import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";
import * as actions from "../../actions";
import {getData, LOGIN} from "../../util/storage";
import {isEmpty, vuepayAlert} from "../../util/utility";
import loading_white from "../../assets/gif/loading_white.gif";

class ReportBroadcastModal extends Component {

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.report_broadcast &&
            nextProps.report_broadcast.payload != null) {
            if (nextProps.report_broadcast.payload.hasOwnProperty("message")) {
                vuepayAlert("success", nextProps.report_broadcast.payload.message);
                this.props.toggleReportBroadcastModal()
            }
            else if (nextProps.report_broadcast.isError) {
                vuepayAlert("error", nextProps.report_broadcast.payload.message);
            }
            this.props.resetReportBroadcast()
        }
    }

    clickedOnReportBroadcast = () => {
        var selectedValue = -1

        if (document.getElementById('broadcast-abusive').checked){
            selectedValue = 1
        }
        if (document.getElementById('broadcast-spam').checked){
            selectedValue = 2
        }
        if (document.getElementById('broadcast-inappropriate').checked){
            selectedValue = 3
        }
        if (document.getElementById('broadcast-other').checked){
            selectedValue = 4
        }

        if (selectedValue === -1){
            vuepayAlert("error", "Please select the appropriate option");
        }
        else {
            getData(LOGIN)
                .then((data) => {

                    var jsonData = {
                        device: this.props.device,
                        report_broadcast_id: selectedValue
                    }
                    if (this.props.private_broadcast_id !== -1) {
                        jsonData.private_session_id = this.props.private_broadcast_id
                    }
                    if(!isEmpty(data)){
                        this.props.reportBroadcast(data.token, data.api_token,this.props.broadcast_id,jsonData)
                    }
                })
        }


    }

    render() {
        return (
            <div id="report-broadcast-modal" className="modal fade" role="dialog" aria-labelledby="myModalLabel"
                 aria-hidden="true">
                <div className="vertical-alignment-helper">
                    <div className="modal-dialog vertical-align-center">
                        <div className="modal-content">
                            <div className="modal-header">
                                {this.props.hideCrossButton !== true && <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                                                               onClick={this.props.toggleReportBroadcastModal}>
                                    <img alt={"close-icon"} src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"}/></button>}
                            </div>
                            <div className="modal-body">

                                <h2>Report Broadcast</h2>

                                <form>
                                    <input type="radio" id="broadcast-abusive" name="gender" value="1"/> Abusive language<br/>
                                        <input type="radio" id="broadcast-spam" name="gender" value="2"/> Spamming<br/>
                                        <input type="radio" id="broadcast-inappropriate" name="gender" value="3"/> Inappropriate behavior <br/>
                                        <input type="radio" id="broadcast-other" name="gender" value="4"/> Other <br/>

                                </form>
                            </div>
                            <div className="modal-footer">
                                {this.props.report_broadcast.isFetching ?
                                    <button type="button" className="btn btn-outline-primary">
                                        <img src={loading_white} alt={"Loading"} width={26} height={26}/>
                                    </button>
                                    :
                                    <button type="button" className="btn btn-outline-primary"
                                            onClick={this.clickedOnReportBroadcast}>Report Broadcast
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        report_broadcast: state.report_broadcast,
        device: state.device.payload,
    };
}

export default connect(mapStateToProps, actions)(ReportBroadcastModal);